module.exports = __webpack_public_path__ + "FILE.png";